var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPolice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_-_police",
    "data-name": "Ico - police",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 36,
    height: 36,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9622",
    "data-name": "Trazado 9622",
    d: "M30.832,7.042a.813.813,0,0,0-.681-.142c-.206.048-4.877,1.14-8.17-4.053a.814.814,0,0,0-1.134-.2.826.826,0,0,0-.2.2c-3.294,5.194-7.965,4.1-8.17,4.053a.817.817,0,0,0-.681.142.78.78,0,0,0-.3.618v8.075c0,7.442,7.869,10.989,9.816,10.989s9.817-3.547,9.817-10.989V7.66a.8.8,0,0,0-.3-.618Zm-5.589,7.933L24.15,16.036a.761.761,0,0,0-.222.7l.253,1.5a.794.794,0,0,1-.317.76.732.732,0,0,1-.459.158.843.843,0,0,1-.38-.095l-1.346-.7a.746.746,0,0,0-.728,0l-1.346.7a.769.769,0,0,1-.84-.064.8.8,0,0,1-.317-.76l.253-1.5a.761.761,0,0,0-.222-.7l-1.093-1.061a.834.834,0,0,1-.19-.824.772.772,0,0,1,.633-.539l1.5-.222a.8.8,0,0,0,.6-.427L20.6,11.6a.831.831,0,0,1,1.425,0l.665,1.361a.8.8,0,0,0,.6.427l1.5.222a.772.772,0,0,1,.633.539.834.834,0,0,1-.19.824Z",
    transform: "translate(-2.968 3.388)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolice);
export default __webpack_public_path__ + "static/media/icon-police.35436e1fcbf07558b4d928cbcaab3620.svg";
export { ForwardRef as ReactComponent };